import React, { useRef, useState } from "react";
import styles from "./DocUploadPopup.module.css";
import { toast } from "react-toastify";
import WebService from "../../Services/WebService";

interface Props {
  open: boolean;
  productId: number;
  onClose: () => void;
}

const DocUploadPopup: React.FC<Props> = ({ open, productId, onClose }) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [uploading, setUploading] = useState(false);

  if (!open) return null;

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      setUploading(true);
      await WebService.fileUploadAPI({
        action: `/v1/door-management/product/images/${productId}`,
        file,
      });
      toast.success("Image uploaded successfully");
      onClose();
    } catch {
      // toast.error("Failed to upload image");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.popup}>
        <h3 className={styles.title}>Upload Product Image</h3>
        <p>Select an image to upload (PNG, JPG up to 5MB)</p>
        <div
          className={styles.input}
          onClick={() => fileInputRef.current?.click()}
          style={{ textAlign: "center", cursor: "pointer" }}
        >
          <input
            type="file"
            ref={fileInputRef}
            accept="image/png, image/jpeg"
            onChange={handleFileChange}
            style={{ display: "none" }}
          />
          Click to select or drag an image here
        </div>
        {uploading && <p className={styles.uploadingText}>Uploading...</p>}
        <div style={{ marginTop: 16 }}>
          <button
            onClick={onClose}
            disabled={uploading}
            className={styles.button}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default DocUploadPopup;
